<template>
	<div>
		<div>
			<div class="live-commands_header">Стартовые составы</div>
									
			<lineup-base :lineup="data.start"></lineup-base>
			
			<div class="live-commands_header">Запасные игроки</div>
			
			<lineup-base :lineup="data.reserv"></lineup-base>
			
			<div class="live-commands_header">Тренеры</div>
			
			<lineup-base :lineup="data.coach"></lineup-base>
		</div>
	</div>
</template>

<script>
	import LineupBase from "./LineupBase";
	
	export default {
		components: {
			LineupBase
		},
		
		props: ['data'],
		
		created() {
			
		}
	}
</script>

<style scoped>

</style>